import projects from '../../_DataStore/projects';

const ProjectsReducer = (state = projects, action) => {
  switch(action.type){
    default:
      return state;
  }
};

export default ProjectsReducer;